"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCursorAtEnd = isCursorAtEnd;
exports.isCursorAtStart = isCursorAtStart;
var _selectionRange = require("./selectionRange");
var _getValue2 = require("./getValue");
function isCursorAtEnd(element) {
  var _getValue;
  var _ref = (0, _selectionRange.getSelectionRange)(element),
    selectionStart = _ref.selectionStart,
    selectionEnd = _ref.selectionEnd;
  return selectionStart === selectionEnd && (selectionStart != null ? selectionStart : /* istanbul ignore next */
  0) === ((_getValue = (0, _getValue2.getValue)(element)) != null ? _getValue : /* istanbul ignore next */
  '').length;
}
function isCursorAtStart(element) {
  var _ref2 = (0, _selectionRange.getSelectionRange)(element),
    selectionStart = _ref2.selectionStart,
    selectionEnd = _ref2.selectionEnd;
  return selectionStart === selectionEnd && (selectionStart != null ? selectionStart : /* istanbul ignore next */
  0) === 0;
}